export function getQuestionList(){
    // return [
    //     ["詳しくあなたの自己紹介をしてください","this is test"]
    // ];
    return [
        ["UFOを信じますか？理由も述べてください",""],
        ["あたなの友人が「近所の人がうるさくて困っている」と言っています",""],
        ["あなたかあなたの友人のペットについて話してください",""],
        ["あなたがもう好きではなくなった歌手について説明してください",""],
        ["あなたが一番最近あやまらなければならなかった時のことを教えてください",""],
        ["あなたが好きなアウトドアスポーツは何ですか？説明してください",""],
        ["あなたが最近参加したセレモニーについて教えてください",""],
        ["あなたが長く使っているものについて話してください",""],
        ["あなたのコンピュータのデータをどうやって管理していますか？",""],
        ["あなたの家に留学生が来ることになりましたあなたの家のルールについて説明してください",""],
        ["あなたの家族について説明してください",""],
        ["あなたの故郷について教えてください",""],
        ["あなたの好きな祝日は何ですか、また、その日は何をしますか？",""],
        ["あなたの今の生活と学生の頃の生活を比較してください",""],
        ["あなたの最寄り駅の周りについて説明してください",""],
        ["あなたの趣味について話してください",""],
        ["あなたの親や友人の車のことについて説明してください",""],
        ["あなたの親戚で一番若いひとについて、どんな人か説明して下さい",""],
        ["あなたの大切な人について話して下さい",""],
        ["あなたの友人が新会社を立ち上げ、あなたに出資を求めていますもっともらしい理由で断ってください",""],
        ["あなたは、顧客とのミーティングに遅れることになりました顧客に説明してください",""],
        ["あなたはTOEICのために勉強していますか？それは何故ですか？",""],
        ["あなたは学生時代どのようなクラブに所属していていましたか？",""],
        ["あなたは朝型ですか、夜型ですかなぜそう思いますか",""],
        ["あなたは平日どうやってすごしますか？",""],
        ["あなたは両親と一緒に子供がずっと住むことに賛成ですか、反対ですか？",""],
        ["あなたは良く睡眠を取りますか？それは何故ですか？",""],
        ["インターネットで最近買い物をしましたかそれにはどんな利点がありますか",""],
        ["ウェイターがオーダーを間違えたら何て言う？",""],
        ["オフィスでのランチについて話してください",""],
        ["オリンピックとは何ですか説明して下さい",""],
        ["カーナビなどのGPSシステムは必要だと思いますか、それはなぜですか",""],
        ["ここ数カ月で一番思い出に残っていることを教えてください",""],
        ["コンピュータが苦手な人について話してください",""],
        ["ストレス解消法を教えてください",""],
        ["スポーツ鑑賞は、生とテレビどっちがいい？",""],
        ["どういういきさつであなたの仕事の分野に興味を持ちましたか",""],
        ["もっともらしい理由で断ってください",""],
        ["一つスポーツを選んで試合のやり方を説明してください",""],
        ["一人っ子の利点はを教えてください",""],
        ["飲みに行くならどんな人と行きますか、それはなぜですか？",""],
        ["英語が上手になると得することは？",""],
        ["英語をなぜ学んでいますか",""],
        ["英語以外のことばを学ぶとしたら、何語でそれはなぜ",""],
        ["家に人を招くのは好きですか？それはなぜですか？",""],
        ["家を購入することと、賃貸する利点をそれぞれ挙げて下さい",""],
        ["家族や友人が乗っている車について教えて下さい",""],
        ["会社での評価のされかたについて説明して",""],
        ["会社で求められる服装はどんなもの",""],
        ["外食の好きな友人はいますか？その人について話してください",""],
        ["外食はどんな時にしますか",""],
        ["休日に時間があるときにあなたは何をしますか？",""],
        ["金曜日の夜に普段あなたは何をしていますか",""],
        ["顧客と大事な打ち合わせがありますどんな準備をしますか",""],
        ["好きなスポーツ選手の名前を一人挙げてくださいまた好きな理由を教えてください",""],
        ["好きな場所について説明して下さい",""],
        ["幸せだなと思う時はいつ",""],
        ["香水をつける人は好き？",""],
        ["最近いった旅行について説明して",""],
        ["最近誰かと食事に行った時のことを話してください",""],
        ["最初、英語の学習を始めた時、どう感じましたか",""],
        ["昨日のできごとについて説明してください",""],
        ["仕事での失敗を教えて下さい",""],
        ["子供のころ好きだったことと今好きなことはなんですか？どんなふうに変わっていますか？",""],
        ["子供の早期英語教育について、賛成ですか、反対ですか？",""],
        ["時間があったらどうやってつぶしますか",""],
        ["自分の母親と今の若い母親を比べてください",""],
        ["重要な会議に出席するときは、どのような準備をしますか？",""],
        ["出張に行くのは好きですか、その理由も話してください",""],
        ["初めて親友に会った時のことを描写してください",""],
        ["将来、都会に住みたいですか田舎に住みたいですか",""],
        ["将来したいことについて説明して下さい",""],
        ["将来身につけたいスキルについて教えて下さい",""],
        ["小説の映画化されたものと原作の違いを言ってください",""],
        ["詳しくあなたの自己紹介をしてください",""],
        ["職場ではスーツを着用しなければいけませんか、それはなぜですか",""],
        ["職場で怒ったりイラついたりしますかどんな時ですか",""],
        ["新聞は紙で読みますか？スマートフォンで読みますか？",""],
        ["親戚との集まりは好き？",""],
        ["前回誰かのためにしたプレゼントは何ですかなぜ、それを選びましたか",""],
        ["待ち合わせをしていた友人が現れないときにあなたはどのような対応をしますか？",""],
        ["電子辞書と紙の辞書どちらがどのように利点があると思いますか",""],
        ["土曜日の午前中の過ごし方について説明してください",""],
        ["冬は好きですか、その理由も含め説明して下さい",""],
        ["同僚に助けられたことはありますか",""],
        ["友人の高価なカーペットにコーヒーをこぼしてしまいました謝って下さいまた、どう綺麗にするか提案して下さい",""],
        ["友人の納得がいくようにアドバイスしてください",""],
        ["友人の部屋が散らかっているときにあなたはどのようなアドバイスをしますか",""],
        ["友達と初めてディスコに行ったときの描写をしてください",""],
        ["欲しい商品の情報をどのように入手していますか",""],
        ["欲しい本が本屋さんで見つかりませんでしたどうしますか？",""],
        ["旅行すならどこにいきたいですか？それはなぜですか？",""],
        ["旅行の計画の仕方について教えてください",""]
    ];
}